import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ClassSubject {
    classId: number;
    className: string;
    subjects: any[];
    termCount: number;
}

interface ClassSubjectsData {
    academicYearId: number | null;
    classSubjects: ClassSubject[];
    boardId: number | null;
    userId: number | null;
}

interface ClassSubjectsState {
    data: ClassSubjectsData;
}

const initialState: ClassSubjectsState = {
    data: {
        academicYearId: null,
        classSubjects: [],
        boardId: null,
        userId: null
    },
};

const classSubjectsSlice = createSlice({
    name: 'classSubjects',
    initialState,
    reducers: {
        setSubjectsData: (state, action: PayloadAction<ClassSubjectsData>) => {
            state.data = action.payload;
        },
    },
});

export const { setSubjectsData } = classSubjectsSlice.actions;
export default classSubjectsSlice.reducer;
